import MobileNavigation from "./MobileNavigation";
import { useFacilityNavLinks } from "@/pages/facilities/[facilityId]/_utils";

export interface MobileFacilityNavigationProps {
  facilityId: string;
}

export default function MobileFacilityNavigation({ facilityId }: MobileFacilityNavigationProps) {
  const navLinks = useFacilityNavLinks(facilityId);

  return <MobileNavigation links={navLinks} section="Manage Facility" testId="mobile-facility-navigation" />;
}
